<template lang="pug">
  el-menu-item(
    index='/rides'
  )
    .img-wrapper
      img(src="@src/assets/sidebar/rides.svg")
    router-link.sub-menu-link(to="/rides")
      span  {{ $t('sidebar.rides') }}
</template>

<script>
import { general } from "@src/services/dynamicViews/general";
import { dynamicViewsConstants } from "@src/constants";
import { mapState } from "vuex";


export default {
  name: "RidesItem",
  mixins: [general],

  computed: {
    ...mapState("auth", ["user"]),
  },

  data() {
    return {
      dynamicViewsConstants
    }
  }
}
</script>
